import { useLocation } from 'react-router-dom';
import { useState } from 'react';

const useFiltersFromLocation = () => {
    const location = useLocation();

    const isValidJSON = (str) => {
        if (typeof str !== 'string') return false;
        try {
            const parsed = JSON.parse(str);
            return typeof parsed === 'object' && parsed !== null;
        } catch (e) {
            return false;
        }
    };

    const [filters, setFilters] = useState(() => {
        const params = new URLSearchParams(location.search);
        if (params.size === 0) return;

        const newFilters = { items: [] };
        params.forEach((value, field) => {
            const isJSON = isValidJSON(value);

            if (isJSON) {
                let v = JSON.parse(value);
                let operator = 'betweenNumbers'

                if (typeof v?.from !== 'number') {
                    operator = 'between'
                }

                newFilters.items.push({
                    field,
                    operator: operator,
                    value: v,
                });
            } else if (value == 'null' || value == 'missing' || value == '_') {
                newFilters.items.push({
                    field,
                    operator: 'isEmpty',
                    value,
                });
            } else if (['_related_legalEntity_commercialCluster', '_related_renter_name'].includes(field)) { // campi che devono avere equals
                newFilters.items.push({
                    field,
                    operator: 'equals',
                    value,
                });
            } else {
                newFilters.items.push({
                    field,
                    operator: 'contains',
                    value,
                });
            }
        });
;
        return newFilters;
    });

    return [filters, setFilters];
};

export default useFiltersFromLocation;
